import axios from 'axios';

// Get backend URL - determined at runtime in browser
const getBackendURL = () => {
  // Check if we're in a browser
  if (typeof window !== 'undefined') {
    const host = window.location.hostname;
    const proto = window.location.protocol;
    
    // Local development
    if (host === 'localhost' || host === '127.0.0.1') {
      return 'http://localhost:8000';
    }
    
    // Production - IP address gets port 8000
    if (/^\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(host)) {
      return proto + '//' + host + ':8000';
    }
    
    // Domain names use same origin
    return proto + '//' + host;
  }
  
  // Fallback for SSR/build time
  return 'http://localhost:8000';
};

// Create axios instance with dynamic baseURL
const apiClient = axios.create();

// Add request interceptor to set baseURL dynamically
apiClient.interceptors.request.use((config) => {
  const backendURL = getBackendURL();
  config.baseURL = backendURL + '/api';
  console.log('🔗 API Request to:', config.baseURL + config.url);
  return config;
});

// Team Members API
export const getTeamMembers = async () => {
  try {
    const response = await apiClient.get('/team');
    return response.data;
  } catch (error) {
    console.error('Error fetching team members:', error);
    throw error;
  }
};

// Categories API
export const getCategories = async () => {
  try {
    const response = await apiClient.get('/categories');
    return response.data;
  } catch (error) {
    console.error('Error fetching categories:', error);
    throw error;
  }
};

// Projects API
export const getProjects = async (category = null) => {
  try {
    const url = category ? `/projects?category=${category}` : '/projects';
    const response = await apiClient.get(url);
    return response.data;
  } catch (error) {
    console.error('Error fetching projects:', error);
    throw error;
  }
};

// Contact Form API
export const submitContactForm = async (formData) => {
  try {
    const response = await apiClient.post('/contact', formData);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Error submitting contact form:', error);
    return { success: false, error: error.message };
  }
};

// Project Inquiry API
export const submitProjectInquiry = async (formData) => {
  try {
    // Convert camelCase to snake_case for backend
    const backendData = {
      name: formData.name,
      email: formData.email,
      phone: formData.phone,
      project_type: formData.projectType,
      location: formData.location,
      budget: formData.budget,
      description: formData.description
    };
    const response = await apiClient.post('/project-inquiry', backendData);
    return { success: true, data: response.data };
  } catch (error) {
    console.error('Error submitting project inquiry:', error);
    return { success: false, error: error.message };
  }
};

// Get all submissions (for admin)
export const getSubmissions = async () => {
  try {
    const response = await apiClient.get('/submissions');
    return response.data;
  } catch (error) {
    console.error('Error fetching submissions:', error);
    throw error;
  }
};